// src/pages/Counselling/Requests/index.tsx
/**
 * `/Counselling/Requests`: the public care-request queue, admin only.
 *
 * Thin shell over `Components/RequestsListView`, matching the `Counselling/Cases` layout.
 */
import RequestsListView from './Components/RequestsListView';

export default function RequestsPage() {
  return <RequestsListView />;
}
